module.exports = __webpack_public_path__ + "static/media/island-tropical.75c0ad90.svg";